
import { BrowserRouter as Router } from 'react-router-dom';
import { Pages } from '../pages/index';

function App() {
  const authenticated = false
	return (
		<Router>
			<Pages auth={authenticated} />
		</Router>
	);
}

export default App;
